import React from 'react';
import StatePropertyTaxPage from '@/components/StatePropertyTaxPage';

const SouthCarolina = () => {
  return (
    <StatePropertyTaxPage
      stateName="South Carolina"
      processDescription="Property owners may appeal their assessment by filing with the county board of assessment appeals within 90 days of the notice mailing. Appeals should include evidence supporting the property owner's claimed fair market value."
      noticeOfValueMailed="June"
      noticeOfValueMailedDateExplanation="Assessment notices are typically mailed in June following county reassessments or annual reviews."
      valuationAsOfDate="December 31"
      valuationAsOfDateExplanation="South Carolina assesses property as of December 31 of the prior year. This year-end assessment date captures property values at the close of the previous calendar year."
      deadlineExplanation="Property owners have 90 days from the notice mailing date to file appeals with the county board of assessment appeals. This typically results in a September deadline."
    />
  );
};

export default SouthCarolina;